import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";

import CleanLayout from "@/layouts/Clean";
import HomeLayout from "@/layouts/Home";

Vue.use(VueRouter);

const LoginPage = () => import("@/views/Login");
const DashboardPage = () => import("@/views/Home");
const shu = () => import("@/views/shu");
const profile = () => import("@/views/profile");
const password = () => import("@/views/password");
const role = () => import("@/views/master/role_setting");
const editrole = () => import("@/views/master/role_setting/editRole");
const master_shu = () => import("@/views/master/master_shu");
const simpanan = () => import("@/views/simpanan");
const pinjaman = () => import("@/views/pinjaman");
const pinjamanmutation = () => import("@/views/pinjaman/mutation");
const simpananDetail = () => import("@/views/simpanan/mutation");
const master_user = () => import("@/views/master_user");
const master_news = () => import("@/views/master/news");
const detailNews = () => import("@/views/detailNews");
const master_newsAdd = () => import("@/views/master/news/add");
const master_newsEdit = () => import("@/views/master/news/edit");

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      redirect: "/login",
      name: "UnAuthenticated",
      component: CleanLayout,
      children: [
        {
          path: "/login",
          name: "Login",
          component: LoginPage,
          meta: {
            guest: true,
          },
        },
      ],
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      redirect: "/dashboard",
      component: HomeLayout,
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: DashboardPage,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/shu",
          name: "SHU",
          component: shu,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/profile",
          name: "Profile",
          component: profile,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/password",
          name: "Password",
          component: password,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/role",
          name: "Role",
          component: role,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/role/:id",
          name: "Edit Role",
          component: editrole,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/master/shu",
          name: "Master SHU",
          component: master_shu,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/simpanan",
          name: "Simpanan",
          component: simpanan,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/simpanan/:jenis/detail/:id",
          name: "Simpanan Detail",
          component: simpananDetail,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/pinjaman",
          name: "Pinjaman",
          component: pinjaman,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/pinjaman/mutation",
          name: "Mutasi Pinjaman",
          component: pinjamanmutation,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/master/user",
          name: "Master User",
          component: master_user,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/master/news",
          name: "Master Berita",
          component: master_news,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/master/news/add",
          name: "Master Berita Add",
          component: master_newsAdd,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/master/news/edit/:id",
          name: "Master Berita Edit",
          component: master_newsEdit,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/:slug",
          name: "Berita",
          component: detailNews,
          alias: "/",
          meta: {
            requireAuth: true,
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const token = Cookies.get("token");
  console.log(to.matched.some((record) => record.meta.requireAuth));
  if (to.matched.some((record) => record.meta.requireAuth)) {
    if (token === null || token === undefined) {
      next("/login");
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (token === null || token === undefined) {
      next();
    } else {
      next("/dashboard");
    }
  }
  // else if (authorize.length && !authorize.includes(currentUser.data.id)) {
  //   return next({ path: "/" });
  // }
});

export default router;
